/**
 * cost_usd is authoritative for money. Everything here formats it and nothing
 * here derives it from tokens -- the three token figures are priced differently
 * and a total built from them is not the basis of any charge.
 */

export function usd(value: number | string | null | undefined, opts?: { precise?: boolean }): string {
  if (value == null) return '—'
  const n = typeof value === 'string' ? Number(value) : value
  if (!Number.isFinite(n)) return '—'
  // Sub-dollar runs are real: DEV-2 cost $0.0954 and its review cost $0.1013.
  // The threshold is a dollar rather than a cent so that two runs of almost the
  // same size never print at different precisions next to each other, which is
  // what made $0.0954 sit beside $0.10 and read as a tenfold difference.
  const digits = opts?.precise || (n > 0 && n < 1) ? 4 : 2
  return `$${n.toFixed(digits)}`
}

/** "1.42M" / "318k" / "949" -- token counts, never summed across kinds. */
export function tokens(value: number | null | undefined): string {
  if (value == null) return '—'
  if (!Number.isFinite(value)) return '—'
  if (Math.abs(value) >= 1_000_000) return `${(value / 1_000_000).toFixed(2)}M`
  if (Math.abs(value) >= 1_000) return `${Math.round(value / 1_000)}k`
  return String(value)
}
